import { render, staticRenderFns } from "./AlarmOrderTable.vue?vue&type=template&id=231bb5de&scoped=true"
import script from "./AlarmOrderTable.vue?vue&type=script&lang=js"
export * from "./AlarmOrderTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmOrderTable.vue?vue&type=style&index=0&id=231bb5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bb5de",
  null
  
)

export default component.exports